/* (ignored) */


//////////////////
// WEBPACK FOOTER
// fs (ignored)
// module id = 305
// module chunks = 1